export const ReplayIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <g
        strokeWidth="1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6.41506 14.2984V18.313H2.40039M6.16234 18.3157C4.78215 16.8728 3.94021 14.9991 3.77778 13.0091C3.61534 11.019 4.1423 9.03357 5.27023 7.38597C6.39817 5.73837 8.05844 4.52883 9.97249 3.96029C11.8865 3.39174 13.9379 3.4988 15.7824 4.26349M6.15818 18.3112C4.67521 16.7613 3.81934 14.7167 3.75594 12.5725C3.69254 10.4284 4.42612 8.33679 5.81493 6.70195C7.20374 5.06711 9.1492 4.00504 11.2754 3.72096C13.4016 3.43688 15.5577 3.95095 17.327 5.16384C19.0963 6.37673 20.3532 8.20235 20.855 10.288C21.3567 12.3736 21.0676 14.5711 20.0436 16.456C19.0195 18.3409 17.3332 19.7793 15.3104 20.4934C13.2876 21.2074 11.072 21.1464 9.09157 20.3221" />
      </g>
    </svg>
  );
};

export default ReplayIcon;
